import React, { ReactNode } from 'react'
import classnames from 'classnames'
import styles from './styles.module.scss'

const Label = ({
  children,
  variant = ''
}: {
  children: ReactNode
  variant?: string
}) => {
  const styleVariations = classnames(styles.formLabel, {
    [styles.secondary]: variant
  })
  return <label className={styleVariations}>{children}</label>
}

export default Label
